<template>
	<div class="service-item" :class="{ active: active }" @click="onItemClick">
		<div class="service-avatar">
			<head-image :size="42" :name="showName" :url="service.headImage" :online="service.online"
				:is-show-user-info="false">
			</head-image>
		</div>
		<div class="service-info">
			<div class="service-name">
				<div class="service-name-text" :title="showName">{{ showName }}</div>
				<div v-if="service.tag" class="service-tag-mini">{{ service.tag }}</div>
			</div>
			<div v-if="service.detail" class="service-detail" :title="service.detail">{{ service.detail }}</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "serviceItem",
	components: {
		HeadImage
	},
	props: {
		service: {
			type: Object,
			required: true
		},
		active: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		showName() {
			return this.service.showNickName || this.service.name;
		}
	},
	methods: {
		onItemClick() {
			this.$emit('select', this.service);
		}
	}
}
</script>

<style scoped lang="scss">
.service-item {
	height: 50px;
	display: flex;
	position: relative;
	align-items: center;
	white-space: nowrap;
	border-radius: 10px;
	margin: 0 3px;
	padding: 5px 8px;
	cursor: pointer;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color: var(--im-background-active-dark);
	}

	.service-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.service-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.service-name {
			display: flex;
			align-items: center;
			overflow: hidden;

			.service-name-text {
				font-size: var(--im-font-size);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.service-tag-mini {
				margin-left: 6px;
				padding: 0 4px;
				font-size: var(--im-font-size-smaller);
				color: var(--im-color-primary);
				border: 1px solid var(--im-color-primary);
				border-radius: 4px;
			}
		}

		.service-detail {
			font-size: var(--im-font-size-smaller);
			color: var(--im-text-color-light);
			margin-top: 2px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
</style>
